import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guid-expired',
  templateUrl: './guid-expired.component.html',
  styleUrls: ['./guid-expired.component.scss']
})
export class GuidExpiredComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
